import type { LearnFAQ } from "@/pages/learn/learnShared";
import {
  makeEsArticle,
  esSaintRelated,
  type EsArticleInput,
} from "./learnFactoryEs";

const reviewBlock = {
  writtenBy: "Neuro Wellness TMS Centers of America",
  reviewedBy: "Daniel Pietras, MD",
  published: "November 3, 2026",
  lastReviewed: "November 3, 2026",
  lastUpdated: "November 3, 2026",
};

const faqs: LearnFAQ[] = [
  {
    question: "¿TMS o SPRAVATO® para la depresión resistente al tratamiento?",
    answer:
      "Ambas son opciones autorizadas por la FDA. La TMS convencional y SAINT® son estimulación magnética. SPRAVATO® (esketamina) es un aerosol nasal. La mejor opción depende del historial del paciente y se evalúa en una consulta.",
  },
];

export const esTmsVsSpravato = makeEsArticle({
  slug: "tms-vs-spravato",
  title: "TMS frente a SPRAVATO® para la depresión",
  description:
    "Comparación de TMS (incluida SAINT®) y SPRAVATO® (esketamina): cómo se administran, duración del efecto e indicaciones para el trastorno depresivo mayor.",
  h1: "TMS frente a SPRAVATO®",
  breadcrumbLabel: "TMS vs SPRAVATO®",
  shortAnswer:
    "La TMS (incluida SAINT®) es una estimulación magnética no invasiva administrada en sesiones en el consultorio. SPRAVATO® (esketamina) es un aerosol nasal autorizado por la FDA para la depresión resistente al tratamiento, administrado bajo supervinación en el consultorio. Ambas son opciones autorizadas por la FDA; la más adecuada depende del historial de cada persona y se evalúa en una consulta con el equipo clínico.",
  keyTakeaways: [
    "La TMS es estimulación magnética no invasiva.",
    "SPRAVATO® es un aerosol nasal administrado bajo supervinación.",
    "Ambas son opciones autorizadas por la FDA para la depresión.",
    "SAINT® está indicada para adultos que no han mejorado con antidepresivos.",
    "La mejor opción se evalúa en una consulta.",
  ],
  sections: [
    {
      heading: "Cómo se administran",
      paragraphs: [
        "La TMS utiliza una bobina magnética colocada sobre el cuero cabelludo para estimular regiones del cerebro. SAINT® combina esto con orientación por fMRI y un calendario acelerado de 50 sesiones en cinco días.",
        "SPRAVATO® (esketamina) es un aerosol nasal que se administra en el consultorio bajo supervinación, con un período de observación tras cada dosis.",
      ],
    },
    {
      heading: "Indicaciones",
      paragraphs: [
        "SAINT® está autorizada por la FDA (510(k) K220177, septiembre de 2022) para el trastorno depresivo mayor en adultos que no han mejorado con antidepresivos. SPRAVATO® está autorizado para la depresión resistente al tratamiento. La elección entre ambos corresponde al equipo clínico y al paciente tras una evaluación.",
      ],
    },
  ],
  faqs,
  sources: [],
  relatedLinks: esSaintRelated,
  reviewBlock,
} satisfies EsArticleInput);
